import { Box, Chip, Typography } from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomTab from 'components/shared/CustomTab/CustomTab';
import { initialAlertState, useAlertStatus } from 'customHook/useAlertStatus';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientService } from 'service/client.service';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setOpenAddLeadDrawer } from 'store/slices/leadsSlice';
import zeplinColor from 'theme/Color';
import Captiv8Chart from './Captiv8Chart/Captiv8Chart';
import DemographicPro from './DemographicPro';

const SocialInsightsPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { alertState, completeOperation, setAlertState, getAlertContent } = useAlertStatus();

  const [tabValue, setTabValue] = useState(0);
  const { addLeadDraft } = useAppSelector((state) => state.leads);
  const [loading, setLoading] = useState(false);
  const [socialEngagement, setSocialEngagement] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  // Fetch Captiv8 user social engagement data
  const getCaptive8Info = async (id: string) => {
    try {
      setLoading(true);
      const res = await ClientService.getCaptive8Info(id);
      console.log('Captiv8 Social Engagement Data:', res);
      setSocialEngagement(res);
      setError(null);
    } catch (err) {
      completeOperation('fetch', 'Failed to fetch Captiv8 social engagement data', true);
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch data when page loads with selected user
  useEffect(() => {
    const id = addLeadDraft?.selectedIntegrations?.captiv8?.[0]?.Id;
    if (id) {
      getCaptive8Info(id);
    }
  }, [addLeadDraft?.selectedIntegrations?.captiv8?.[0]?.Id]);

  const handleBack = () => {
    dispatch(setOpenAddLeadDrawer(true));
    navigate('/leads');
  };
  const Tabs = [
    {
      label: 'Captiv8',
      id: 1,
      isHidden: tabValue !== 0,
      Component: <></>,
    },
    {
      label: 'Demographic Pro',
      id: 2,
      isHidden: tabValue !== 1,
      Component: <></>,
    },
  ];

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' }}>
      {/* header of social insights */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box
              sx={{
                width: '52px',
                height: '52px',
                borderRadius: '12px',
                backgroundColor: zeplinColor.BasicBlack,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={socialEngagement?.avatar}
                alt='social-insights-user'
                width='52px'
                height='52px'
                style={{ borderRadius: '12px' }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8x' }}>
              <Typography variant='responsiveHeading3'>{socialEngagement?.name || 'NA'}</Typography>
              <Chip
                label={
                  <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                    {}
                  </Typography>
                }
                sx={{
                  backgroundColor: zeplinColor.BasicBlack,
                  padding: '5px 12px 5px 12px',
                  borderRadius: '50px',
                  height: '24px',
                }}
              />
            </Box>
          </Box>
          <Box sx={{ marginTop: '24px' }}>
            <CustomTab tabs={Tabs} handleChange={handleTabChange} value={tabValue} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', width: 'fit-content' }}>
          <CustomButton
            disabled={false}
            onClick={() => handleBack()}
            variant='outlined'
            style={{
              borderRadius: '14px',
              height: 56,
              width: 'fit-content',
              border: `1px solid ${zeplinColor.BasicBlack}`,
            }}
            textStyle={{ color: zeplinColor.BasicBlack }}
            text={'Edit Lead Details'}
          />
          <CustomButton
            disabled={false}
            onClick={() => handleBack()}
            variant='outlined'
            style={{
              borderRadius: '14px',
              height: 56,
              width: 'fit-content',
              border: `1px solid ${zeplinColor.BasicBlack}`,
            }}
            textStyle={{ color: zeplinColor.BasicBlack }}
            icon={
              <img src='/assets/ai-deep-dive.svg' alt='AI Deep Dive' width='20px' height='20px' />
            }
            iconPosition='start'
            text={'Run AI Deep-Dive'}
          />
          <CustomButton
            disabled={false}
            onClick={() => handleBack()}
            variant={'contained'}
            color={'primary'}
            style={{
              borderRadius: '14px',
              height: 56,
              width: 'fit-content',
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'Create Lead'}
          />
        </Box>
      </Box>
      {/* end of header */}
      {/* Tab Content */}
      <Box sx={{}}>
        {tabValue === 0 ? (
          <Captiv8Chart socialEngagement={socialEngagement} loading={loading} error={error} />
        ) : (
          <DemographicPro />
        )}
      </Box>
      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </Box>
  );
};
export default SocialInsightsPage;
